import { render, staticRenderFns } from "./UserJourney.vue?vue&type=template&id=81aae1da&scoped=true"
import script from "./UserJourney.vue?vue&type=script&lang=ts"
export * from "./UserJourney.vue?vue&type=script&lang=ts"
import style0 from "./UserJourney.vue?vue&type=style&index=0&id=81aae1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aae1da",
  null
  
)

export default component.exports